var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rocket-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0682 8.65233L18.049 6.67157C20.2793 4.44128 23.1992 3.51617 26.2893 3.365C27.4913 3.3062 28.0922 3.2768 28.5741 3.75872C29.0561 4.24063 29.0266 4.84159 28.9678 6.04353C28.8166 9.13368 27.8916 12.0536 25.6613 14.2838L23.6805 16.2646C22.0493 17.8958 21.5856 18.3597 21.928 20.129C22.266 21.4806 22.593 22.7894 21.6102 23.7722C20.4181 24.9643 19.3306 24.9643 18.1385 23.7722L8.56061 14.1943C7.36849 13.0022 7.36845 11.9147 8.56061 10.7226C9.5434 9.7398 10.8522 10.0669 12.2038 10.4049C13.9732 10.7473 14.437 10.2835 16.0682 8.65233Z",
    stroke: "#005F89",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.9944 9.33301H23.0064",
    stroke: "#005F89",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.6665 28.6667L10.3332 22",
    stroke: "#005F89",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.6665 28.6667L14.3332 26",
    stroke: "#005F89",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.6665 20.6667L6.33317 18",
    stroke: "#005F89",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket01);
export default __webpack_public_path__ + "static/media/rocket-01.31c6eab6b5954862ea1968a63576c634.svg";
export { ForwardRef as ReactComponent };